export default class ContactFormDTO {
    /**
     * @type{string}
     */
    name;

    /**
     * @type{string}
     */
    email;

    /**
     * @type{string}
     */
    message;

    /**
     * Honeypot field - stays empty for real users, bots fill it in
     * @type{string}
     */
    website;

    constructor() {
        this.name = '';
        this.email = '';
        this.message = '';
        this.website = '';
    }
}
